import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "space-y-6"
};
const _hoisted_2 = {
  class: "d-flex align-center ga-4"
};
const _hoisted_3 = {
  class: "d-flex align-center ga-4"
};
const _hoisted_4 = {
  key: 0,
  class: "mt-6"
};
const _hoisted_5 = {
  class: "d-flex align-center ga-4"
};
const _hoisted_6 = {
  class: "d-flex justify-space-between align-center w-100"
};
const _hoisted_7 = {
  class: "d-flex ga-2"
};
import { ref, reactive, computed, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import LlTextField from '@/components/LlTextField.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlDoubleSwitch from '@/components/LlDoubleSwitch.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
export default {
  __name: 'PracticeAreaEdit',
  props: {
    // Core Angular services (automatically injected by main.js)
    userService: {
      type: Object,
      required: false
    },
    leanLawApi: {
      type: Object,
      required: false
    },
    alerts: {
      type: Object,
      required: false
    },
    modalService: {
      type: Object,
      required: false
    },
    // Dialog props
    modelValue: {
      type: Boolean,
      default: false
    },
    tag: {
      type: Object,
      default: null
    },
    allTags: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'save', 'delete', 'cancel'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Initialize Pinia stores
    const meStore = useMeStore();
    const {
      me
    } = storeToRefs(meStore);

    // Refs
    const formRef = ref(null);
    const deleteConfirmRef = ref(null);

    // Reactive state
    const formData = reactive({
      label: '',
      default: false
    });
    const reassignTag = ref(null);
    const shouldFocus = ref(false);

    // Computed properties
    const showDialog = computed({
      get: () => props.modelValue,
      set: value => emit('update:modelValue', value)
    });
    const saving = computed(() => false);
    const deleting = computed(() => false);
    const reassignOptions = computed(() => {
      if (!props.allTags || !props.tag?.id) return [];
      return props.allTags.filter(t => t.id !== props.tag.id);
    });
    const nameRules = computed(() => [v => !!v?.trim() || 'Name is required', v => (v?.trim()?.length || 0) <= 100 || 'Name must be less than 100 characters']);
    const canSave = computed(() => {
      return formData.label?.trim() && !reassignTag.value;
    });
    const deleteConfirmMessage = computed(() => {
      if (reassignTag.value) {
        return `Are you sure? The matters assigned to '${props.tag?.label}' will be reassigned to '${reassignTag.value.label}'. It cannot be undone.`;
      }
      return "Are you sure? Any matters assigned to this will have the practice area removed. It cannot be undone.";
    });

    // Watch for tag changes to update form
    watch(() => props.tag, newTag => {
      if (newTag) {
        formData.label = newTag.label || '';
        formData.default = newTag.default === true || newTag.default === 'true';
        shouldFocus.value = !newTag.id;
      } else {
        // Reset form for new tag
        formData.label = '';
        formData.default = false;
        shouldFocus.value = true;
      }
      reassignTag.value = null;
    }, {
      immediate: true
    });

    // Watch for dialog open to set focus
    watch(showDialog, async isOpen => {
      if (isOpen && shouldFocus.value) {
        await nextTick();
        // Focus will be handled by autofocus on the text field
      }
    });

    // Methods
    const handleSave = async () => {
      if (!canSave.value) return;
      const {
        valid
      } = await formRef.value.validate();
      if (!valid) return;
      const tagData = {
        label: formData.label.trim(),
        default: formData.default
      };
      if (props.tag?.id) {
        tagData.id = props.tag.id;
      }
      emit('save', tagData);
    };
    const handleDelete = async () => {
      try {
        const confirmed = await deleteConfirmRef.value.open();
        if (!confirmed) return;
        const deleteData = {
          reassign: reassignTag.value ? reassignTag.value.id : null,
          delete: true,
          tag: props.tag
        };
        emit('delete', deleteData);
      } catch (error) {
        // Error handling if confirmation dialog fails
        console.error('Error with delete confirmation:', error);
      }
    };
    const handleCancel = () => {
      reassignTag.value = null;
      emit('cancel');
    };
    const closeDialog = () => {
      reassignTag.value = null;
      emit('update:modelValue', false);
    };

    // Expose methods for parent component if needed
    __expose({
      formData,
      handleSave,
      handleDelete,
      handleCancel
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_label = _resolveComponent("v-label");
      const _component_v_form = _resolveComponent("v-form");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showDialog.value = $event),
        "max-width": "600px",
        persistent: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "d-flex justify-space-between align-center"
          }, {
            default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("span", {
              class: "text-h6"
            }, "Practice Area", -1)), _createVNode(LlSecondaryButton, {
              icon: "mdi-close",
              variant: "text",
              size: "small",
              "aria-label": "Close",
              onClick: handleCancel,
              "data-cy": "close-modal"
            })]),
            _: 1
          }), _createVNode(_component_v_card_text, {
            class: "py-4"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_form, {
              ref_key: "formRef",
              ref: formRef,
              onSubmit: _withModifiers(handleSave, ["prevent"])
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_v_label, {
                class: "text-sm font-weight-medium",
                style: {
                  "min-width": "100px"
                }
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" Name ", -1)]))]),
                _: 1
              }), _createVNode(LlTextField, {
                modelValue: formData.label,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.label = $event),
                placeholder: "Practice Area Name",
                variant: "outlined",
                density: "compact",
                class: "flex-grow-1",
                rules: nameRules.value,
                "validate-on": "input lazy",
                autofocus: "",
                "data-cy": "practice-area-name"
              }, null, 8, ["modelValue", "rules"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_v_label, {
                class: "text-sm font-weight-medium",
                style: {
                  "min-width": "100px"
                }
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Default ", -1)]))]),
                _: 1
              }), _createVNode(LlDoubleSwitch, {
                modelValue: formData.default,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.default = $event),
                "left-label": "No",
                "right-label": "Yes",
                density: "compact",
                class: "flex-grow-1",
                "data-cy": "default-switch"
              }, null, 8, ["modelValue"])]), __props.tag?.id && __props.tag?.matterCount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[8] || (_cache[8] = _createElementVNode("div", {
                class: "mb-4"
              }, [_createElementVNode("span", {
                class: "text-sm text-grey-darken-1"
              }, " If you are deleting the practice area you can reassign matters to a different one: ")], -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_v_label, {
                class: "text-sm font-weight-medium",
                style: {
                  "min-width": "100px"
                }
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Reassign ", -1)]))]),
                _: 1
              }), _createVNode(LlSelect, {
                modelValue: reassignTag.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => reassignTag.value = $event),
                items: reassignOptions.value,
                "item-title": "label",
                "item-value": "id",
                placeholder: "Select practice area",
                variant: "outlined",
                density: "compact",
                class: "flex-grow-1",
                clearable: "",
                "return-object": "",
                "data-cy": "reassign-select"
              }, null, 8, ["modelValue", "items"])])])) : _createCommentVNode("", true)])]),
              _: 1
            }, 512)]),
            _: 1
          }), _createVNode(_component_v_card_actions, {
            class: "px-6 pb-6"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
              onBtnClick: handleCancel,
              "data-cy": "cancel-practice-area"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Cancel ", -1)]))]),
              _: 1
            })]), _createElementVNode("div", _hoisted_7, [__props.tag?.id ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              variant: "flat",
              color: reassignTag.value ? 'primary' : 'error',
              loading: deleting.value,
              onBtnClick: handleDelete,
              "data-cy": "delete-practice-area"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(reassignTag.value ? 'Reassign' : 'Delete'), 1)]),
              _: 1
            }, 8, ["color", "loading"])) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
              variant: "flat",
              color: "primary",
              disabled: !canSave.value,
              loading: saving.value,
              onBtnClick: handleSave,
              "data-cy": "save-practice-area"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.tag?.id ? 'Save' : 'Create'), 1)]),
              _: 1
            }, 8, ["disabled", "loading"])])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(LlConfirmationDialog, {
          ref_key: "deleteConfirmRef",
          ref: deleteConfirmRef,
          title: "Confirm delete",
          message: deleteConfirmMessage.value,
          "confirm-text": "OK",
          "toggle-text": "Cancel",
          "data-cy": "delete-confirmation"
        }, null, 8, ["message"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};